export default {
    root: {
        "&$hover": {
            cursor: "pointer"
        }
    }
}
